import { isApp } from '@zet/utils'
import { navigationRef } from '@zet/utils/navigation'
import { useModal as useRnModal } from 'react-native-modalfy'

type payloadType = {
  videoId?: string
  videoData?: object
  onCloseModal?: () => void
}

function useModal() {
  const modalOptions = useRnModal()
  const openModalWithTimeTracking = (
    modalName: string,
    payload?: payloadType,
  ) => {
    if (modalName === 'YoutubeVideoModal' && isApp) {
      navigationRef.navigate('TraingVideoPlayer', {
        videoId: payload?.videoId,
        youtube_video_details: payload?.videoData,
        isGenericVideoPlayer: true,
        closeCallback: payload?.onCloseModal,
      })
    } else {
      modalOptions.openModal(modalName, payload)
    }
  }
  return {
    ...modalOptions,
    openModal: openModalWithTimeTracking,
  }
}

export { useModal }
